import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';

// import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
// import { getFormattedTime } from '../../common/dateHelper';
import { convertFileSize, getFileTypeLabelsByFilename } from '../../common/fileHelper';
import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdFileTypeIcon from '../../common/elemental/AfitdFileTypeIcon';

import cx from 'clsx';
// import { format } from 'date-fns';
// import _get from 'lodash/get';
// import _set from 'lodash/set';
// import _map from 'lodash/map';

const styles = theme => ({
    //chatRightBlock2In
    root: {},
    contentContainerOut: {
        display: 'flex',
        justifyContent: 'space-between',
        background: '#FFFFFF',
        border: '1px solid #F0F2F6',
        padding: '12px',
        // fontSize: '16px',
        // lineHeight: '23px',
        borderRadius: '4px',
        // cursor: 'pointer',
    },
    fileInfoContainer: {
        flex: 1,
        marginLeft: '20px',
    },
    fileLink: {
        textDecoration: 'none',
    },
    //chatRightBlock2In small
    messageAgeText: {
        marginLeft: '10px',
        fontSize: '13px',
    },
    hidden: {
        display: 'none',
    },
});

const getDefns = params => {
    const { props } = params;
    const { classes, attachment, onClear, isClickable = true } = props;
    const { hidden: hiddenCls } = classes;
    const { size = 0, title = '', url = '' } = attachment;

    const { size: convertedSize, unit } = convertFileSize(size);
    const { label: typeLabel, labelLong: typeLabelLong } = getFileTypeLabelsByFilename(title);

    const defns = {
        fileLink: {
            target: '_blank',
            href: isClickable ? url : undefined,
        },
        fileTypeIcon: {
            label: typeLabel,
        },
        filenameText: {
            variant: 'body2',
            value: title,
        },
        fileTypeSizeText: {
            variant: 'caption',
            clsGrayColor: true,
            value: `${typeLabel} ${typeLabelLong} ${convertedSize}${unit}`,
        },
        clearIconButtonContainer: {
            className: cx({ [hiddenCls]: onClear === undefined }),
        },
        clearIconButton: {
            onClick: handleClickClearIconButton.bind(null, onClear),
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

const handleClickClearIconButton = onClear => {
    if (onClear) onClear();
};

const MessageFileBlock = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    // const context = useContext(LayoutContext);
    // const xxxxxx = _get(context, 'xxxxxx');
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    // const [yyyyyyyyy, setYyyyyyyyy] = useState();
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    const { isHidden, attachment } = props;
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    // useEffect(() => {
    //     const newDefns = getDefns(props, { });
    //     setDefns(newDefns);
    // }, [props]);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    if (isHidden || !attachment) {
        return null;
    } else {
        //---------------------------------------------------------------------
        // Defns
        const defns = getDefns({ props });
        //---------------------------------------------------------------------
        return (
            <div {...defns.root}>
                <a {...defns.fileLink}>
                    <div {...defns.contentContainerOut}>
                        <AfitdFileTypeIcon {...defns.fileTypeIcon} />
                        <div {...defns.fileInfoContainer}>
                            <AfitdTypography {...defns.filenameText} />
                            <AfitdTypography {...defns.fileTypeSizeText} />
                        </div>
                        <div {...defns.clearIconButtonContainer}>
                            <IconButton {...defns.clearIconButton}>
                                <ClearIcon />
                            </IconButton>
                        </div>
                    </div>
                </a>
            </div>
        );
    }
    //---------------------------------------------------------------------
};

export default withStyles(styles)(MessageFileBlock);
